import { EncodeJsonBase64 } from '@/lib/EncodeJsonBase64';
import { getUserInputEventDebugInfo } from './form';
import { focusByClass } from './shared/focusByClass';
import { getQueryStrings } from './shared/QueryParams';
import { trackByName } from './tracking';
import { DeepPartialExcept } from './types/lib/DeepPartial';
import { useAppSelector } from '@/hooks';

export const openExtern = (devkey) => {
  return async (dispatch, getState: RootStateGetter) => {
    const state = getState();

    const usedEnsOptions = { ...state.ensOptions, openExternAfterSelect: undefined, devicekey: devkey };

    const usedEnsPreset =
      Object.keys(state.ensPreset.ensPreset || {}).length === 0 ? null : { ...state.ensPreset.ensPreset };

    //query params übernehmen

    const targetUrl = new URL(state.ensfields.customCalculatorPage);
    targetUrl.searchParams.set('ensOptionsOverride', EncodeJsonBase64.encodeObjectToBase64(usedEnsOptions));

    if (usedEnsPreset)
      targetUrl.searchParams.set('ensPresetOverride', EncodeJsonBase64.encodeObjectToBase64(usedEnsPreset));
    if (window.ensStyling)
      targetUrl.searchParams.set('ensStylingOverride', EncodeJsonBase64.encodeObjectToBase64(window.ensStyling));

    const queryParamsWhitelist = [
      'ensCountryCode',
      'ensFilter',
      'ensDisableSaveEntryQuestion',
      'ensVoucherCode',
      'hideMitarbeiterkennung',
      'predef',
      'predef_no_referer',
      'presetId',
      'refererId',
      'devmode',
      'noping',
    ];
    const originalQueryParams = getQueryStrings();
    for (const queryKey in originalQueryParams) {
      if (!queryParamsWhitelist.includes(queryKey)) continue;
      targetUrl.searchParams.set(queryKey, originalQueryParams[queryKey]);
    }

    window.open(targetUrl.toString(), '_blank');
  };
};

const isOpenExtern = (state: DeepPartialExcept<RootState, { ensOptions: { openExternAfterSelect: string } }>) => {
  return state.ensOptions?.openExternAfterSelect || getQueryStrings()?.ensOpenExternAfterSelect;
};

export const useIsOpenExtern = () => {
  const openExternAfterSelect = useAppSelector((state) => state.ensOptions.openExternAfterSelect);

  return isOpenExtern({ ensOptions: { openExternAfterSelect } });
};

export const selectDevMode = (devkey, skipFocus = false) => {
  return async (dispatch, getState: RootStateGetter) => {
    if (isOpenExtern(getState())) {
      openExtern(devkey)(dispatch, getState);
      return;
    }

    await dispatch({ type: 'DEVICEMODE_SELECTED', devkey, ...getUserInputEventDebugInfo() });
    dispatch(trackByName('devicemode_selected'));

    if (!skipFocus) {
      dispatch(focusByClass('ensOverviewInputPrice'));
    }

    /**
     * S-Pedelec Rechner: Schutzbrief-Filter standardmäßig deaktiviert
     * @link https://app.asana.com/0/1174272655772669/1202209469535340
     */
    if (devkey === 'spedelec' || devkey === 'gewerblich') {
      await dispatch({
        type: 'CHANGE_USER_INPUT',
        value: {
          fieldName: 'withSchutzbrief',
          fieldValue: false,
        },
      });
    }
  };
};
